<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/login2.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white bg-dark">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">تسجيل الدخول</h4>
                                    <p>مرحباً بك مجدداً، الرجاء الدخول إلى حسابك</p>
                                </div>
                                <vs-input
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    icon-no-border
                                    label-placeholder="البريد الإلكتروني"
                                    v-model="email"
                                    @keyup.enter="login"
                                    class="w-full no-icon-border"/>

                                <vs-input
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    icon-no-border
                                    label-placeholder="كلمة المرور"
                                    v-model="password"
                                    @keyup.enter="login"
                                    class="w-full mt-6 no-icon-border" />

                                <div v-if="errorMsg" class="mt-2">
                                  <span class="text-danger">{{ errorMsg }}</span>
                                </div>

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox v-model="remember_me" class="mb-3">تذكرني</vs-checkbox>
                                    <router-link class="hover:underline" to="/identify-user">نسيت كلمة المرور؟</router-link>
                                </div>
                                <div class="flex flex-wrap justify-end items-center">
                                  <vs-button class="lg:w-auto w-full mb-4" :disabled="load" @click="login">
                                    تسجيل الدخول{{ !load ? '' : '...' }}
                                  </vs-button>
                                </div>
                                <div>
                                    ليس لديك حساب؟
                                    <router-link class="lg:w-auto w-full lg:order-first order-last mb-4 hover:underline" type="border" to="/register">انشاء حساب جديد</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import authAPI from '@/api/authAPI'

export default {
    data() {
        return {
            email: '',
            password: '',
            remember_me: false,
            errorMsg: null,
            load: false,
        }
    },

    computed: {
        validateForm() {
            return this.email !== '' && this.password !== '';
        },
    },
    methods: {
        errorMessages(status) {
            switch (status) {
                case 'incorrect_email_password': return 'البريد الالكتروني أو كلمة المرور غير صحيحة'
                case 'not_verified' : return 'هذا الحساب لم يتم تأكيده بعد، الرجاء تأكيد حسابك عن طريق بريدك الإلكتروني.'
                case 'pending': return 'لم يتم تأكيد حسابك من قبل مدير نظام الكلية بعد.'
                case 'suspended': return 'لقد تم وقف حسابك، الرجاء التواصل مع مدير نظام الكلية.'
                default: return 'انت غير مصرح للدخول، إذا كانت هناك مشكله الرجاء التواصل مع مدير نظام الكلية.'
            }
        },
        login() {
            if(!this.validateForm) return
            this.load = true
            this.errorMsg = null
            let loginData = {email: this.email, password: this.password, remember_me: this.remember_me}
            this.$store.dispatch('auth/login', loginData)
                .then(({data}) =>  {
                    if(data.message === 'failed'){
                        if(data.code === 401){
                            this.errorMsg = this.errorMessages(data.error)
                        } else if (data.code === 403){
                            if(data.status === 'not_allowed') {
                                const facultyName = this.$store.state.facultyInfo.name
                                const title = 'حسابك غير مخول في هذه الكلية'
                                const text = `لم تقم بالتسجيل في هذه الكلية من قبل، هل ترغب بتسجيل حسابك بـ${facultyName} ؟`
                                this.$confirmAlert(title, text, () => {
                                    authAPI.requestTeacherRole(loginData)
                                        .then(() => {
                                          this.$notifySuccess(
                                              'الرجاء الإنتظار حتى يقوم مدير نظام الكلية بالموافقة علي طلب تسجيلك.',
                                              'لقد تم إرسال طلبك بنجاح'
                                          )
                                        })
                                        .catch(error => this.$notifyError(error.statusMessage))
                                }, 'warning')
                            } else {
                                this.errorMsg = this.errorMessages(data.status)
                            }
                        }
                    } else {
                        if(this.hasRole('student') || this.hasRole('teacher')){
                            this.$router.push('/')
                        }
                        else if (this.hasRole('admin')) {
                            this.$router.push('/admin')
                        }
                    }

                })
                .catch(error => {
                    if(error.request) this.$notifyError('توجد مشكلة في الخادم، يرجى المحاولة مرة اخرى')
                })
                .finally(() => this.load = false)
        },
        hasRole(roleName) {
            let hasRole = false
            this.$store.getters['auth/user'].roles.forEach(function(role) {
                if(role['name'].toLowerCase() === roleName.toLowerCase()) {
                    hasRole = true;
                }
            })
            return hasRole
        },
    }
}
</script>
